// extracted by mini-css-extract-plugin
export default {"PersonalForm":"PersonalForm_PersonalForm__zt2gF","TitularLabel":"PersonalForm_TitularLabel__KJjyG","Titular":"PersonalForm_Titular__cC+x5","Gender":"PersonalForm_Gender__r461g"};